import { render, staticRenderFns } from "./jiaoxue.vue?vue&type=template&id=7423d5f0&scoped=true&"
import script from "./jiaoxue.vue?vue&type=script&lang=js&"
export * from "./jiaoxue.vue?vue&type=script&lang=js&"
import style0 from "./jiaoxue.vue?vue&type=style&index=0&id=7423d5f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7423d5f0",
  null
  
)

export default component.exports